import React from 'react';
import PropTypes from 'prop-types';

import withOverridableCurrency from './hoc/withOverridableCurrency';

const localeByCurrency = {
  CAD: 'en-CA',
  AUD: 'en-AU',
};

export function getSymbolForCurrency(currency = 'USD') {
  const locale = localeByCurrency[currency.toUpperCase()] || 'en-US';
  if (currency.toUpperCase() === 'MIXED') {
    return undefined;
  }

  return (0).toLocaleString(locale, {
    locale,
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).slice(0, -1);
}

export function formatNumber(cents, precision = 2) {
  const amount = cents / (10 ** precision);
  return amount.toLocaleString('en-US', {
    style: 'decimal',
    minimumFractionDigits: precision,
    maximumFractionDigits: Math.max(2, precision),
  });
}

export function formatAmount(cents, currency = 'USD', precision = 2) {
  const amount = cents / 100;
  const locale = localeByCurrency[currency.toUpperCase()] || 'en-US';
  const format = {
    style: 'currency',
    minimumFractionDigits: precision,
    maximumFractionDigits: Math.max(2, precision),
  };

  if (currency.toUpperCase() === 'MIXED') {
    return amount.toLocaleString(locale, { ...format, currency: 'USD' }).slice(1);
  }

  return amount.toLocaleString(locale, { ...format, currency });
}

const Money = ({ cents, currency, children, precision, automationId }) => {
  const value = typeof children === 'number' ? children : cents || 0;

  return (
    <span data-automation-id={automationId}>{formatAmount(value, currency, precision)}</span>
  );
};

Money.propTypes = {
  cents: PropTypes.number,
  currency: PropTypes.string,
  children: PropTypes.number,
  precision: PropTypes.number,
  automationId: PropTypes.string,
};
Money.defaultProps = {
  cents: 0,
  currency: 'USD',
  children: null,
  precision: 2,
  automationId: null,
};

export default withOverridableCurrency(Money);
